module.exports = __webpack_public_path__ + "media/apps/mitch-ios-6-0501357b.png";